import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from 'react-native-fast-image';
import {TouchableOpacity} from 'react-native';

export const Container = styled(TouchableOpacity)`
  background: transparent;
  padding: ${RFValue(9)}px 24px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border2};
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const ProductInfos = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Photo = styled(FastImage)`
  height: ${RFValue(54)}px;
  width: ${RFValue(54)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(14)}px;
`;

export const Info = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const RegularPrice = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const RegulaPriceSpot = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PriceContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Price = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const NormalPriceContainer = styled.View`
  position: 'relative';
  margin-left: ${RFValue(6)}px;
`;

export const NormalPrice = styled(Price)`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text_2};
  position: relative;
`;

export const LineThrough = styled.View`
  width: 100%;
  height: 1px;
  background-color: ${({theme}) => theme.colors.text_2};
  position: absolute;
  left: 0;
  right: 0;
  bottom: 8px;
`;
